import { BlogsCubit, IBlogsCubit } from "../blocs/blog/BlogsBloc";
import BlogsList from "./BlogsList";

const portfolioCubit: IBlogsCubit = new BlogsCubit(["project"])
portfolioCubit.getAllBlogs();

export function PortfolioPage() {
    return <BlogsList
        title="Portfolio"
        blogsCubit={portfolioCubit}
        showCategories={false}
    />
}